<template>
  <div class="texto-wrapper mt-4">
    <h6 class="font-weight-bold">Cobertura vacinal contra o HPV</h6>
    <p>
      Uma das maneiras de avaliar uma política de saúde é verificar se as metas esperadas estão
      sendo alcançadas. Indicadores de cobertura vacinal são extremamente úteis para essa função,
      pois informam quantas pessoas realmente estão sendo atendidas por essa política.
    </p>
    <p>
      No Brasil, a vacina que protege contra o HPV foi incorporada ao Sistema Único de Saúde (SUS)
      em 2014, com aplicação da vacina quadrivalente, tendo como intuito principal a redução do
      câncer de colo do útero. A vacina confere imunidade contra os tipos virais 6 e 11
      (responsáveis por 90% dos casos de verrugas genitais) e 16 e 18 (responsáveis por 70% dos
      casos de câncer de colo de útero).
    </p>
    <p>
      <span class="text-underline">Indicação e esquema vacinal na rotina:</span>
      <br>
      Dose única para meninos e meninas, de 9 a 14 anos (14 anos, 11 meses e 29 dias).
    </p>
    <p>
      <span class="text-underline">Método de cálculo para cobertura vacinal contra o HPV:</span>
      <br>
    </p>
    <ul class="no-style-list">
      <li>
        <b>A</b> - Número de meninas e meninos, de 09 a 14 anos, residentes no município, que
        apresentarem o esquema vacinal de uma dose  contra o HPV
      </li>
      <li><b>B</b> - Número de meninas e meninos, de 09 a 14 anos residentes no município</li>
    </ul>
    <div class="border border-dark text-center mb-3">
      <p class="small-text mt-2 mb-2">
        <b>A</b> / <b>B</b> x 100
      </p>
    </div>
    <p>
      Fontes de dados:
      <br>
      Localiza Sus: Doses aplicadas
      <br>
      IBGE: População alvo
    </p>
    <p>
      Para o cálculo da cobertura vacinal a coorte de meninos e meninas, de 09 a 14 anos, deve ser
      acompanhada no tempo, uma vez que a dose da vacina contra o HPV pode ser aplicada a qualquer
      momento deste intervalo etário.
    </p>
    <hr>
    <p>
      <span class="text-underline">Análise do indicador de cobertura vacinal contra o HPV</span>
    </p>
    <p>
      A cobertura vacinal é acompanhada segundo o número de pessoas registradas que receberam o
      esquema vacinal de uma dose. Para avaliar se o município atingiu ou não a meta de cobertura
      vacinal, utilizam-se os seguintes parâmetros:
    </p>
    <ul>
      <li>
        Menos de 50% de cobertura vacinal =
        <span class="meta meta--ruim">MUITO ABAIXO DA META</span>
      </li>
      <li>
        Entre 50% e 79% de cobertura vacinal = <span class="meta meta--medio">ABAIXO DA META</span>
      </li>
      <li>
        80% ou mais de cobertura vacinal = <span class="meta meta--boa">META ATINGIDA</span>
      </li>
    </ul>
    <p>
      Para cada uma dessas situações, são fornecidos planos de ação (link) para auxiliar o gestor
      municipal a manter ou atingir as metas de cobertura vacinal.
    </p>
    <p>Referências</p>
    <p>
      1. Organização Pan-Americana da Saúde. Metodologia para o cálculo de cobertura da vacina
      contra o HPV na Região das Américas. Washington, D.C.: OPAS; 2019. Disponível em:
      <a class="word-break-all" :href="urlReferencias1" target="_blank">{{ urlReferencias1 }}</a>
    </p>
    <p>
      2. MINISTÉRIO DA SAÚDE. Coorte de vacinados HPV. Ministério da Saúde, Brasília, 2022.
      Disponível em:
      &lt;<a class="word-break-all" :href="urlReferencias2" target="_blank">
        {{ urlReferencias2 }}
      </a>&gt;.
      Acesso em: 14 deout. de 2022.
    </p>
  </div>
</template>

<script>
export default {
  name: 'texto-explicativo-vacinacao-hpv',
  data: () => ({
    urlReferencias1: 'https://iris.paho.org/bitstream/handle/10665.2/51663/9789275721513_por.pdf?sequence=1&isAllowed=y',
    urlReferencias2: 'https://app.powerbi.com/view?r=eyJrIjoiMmQ0OGIzMzQtMWJiOC00ZWNjLWE3NDgtOGJlODA3YmEwZTQ5IiwidCI6IjlhNTU0YWQzLWI1MmItNDg2Mi1hMzZmLTg0ZDg5MWU1YzcwNSJ9&pageName=ReportSection887019241e202c402ba4',
  }),
};
</script>

<style lang="scss" scoped>
a { font-weight: bold; }

.word-break-all { word-break: break-all; }

.meta {
  font-weight: bold;
  &--boa {color: #0AB87F;}
  &--medio {color: #F8950E;}
  &--ruim {color: #D53C3C;}
}

.small-text { font-size: .875rem }

.text-underline { text-decoration: underline; }

.tabela-coorte-wrapper { overflow-x: scroll; }

.no-style-list { list-style: none; }

@include media-breakpoint-up(md) {
  .tabela-coorte-wrapper {
    overflow-x: auto;
    img { width: 100%; }
  }
}
</style>
